import type { PullRequestAgentEdit } from '../../../../../api/agent-miner-client/agent-miner-client.type';

/**
 * Orders a file's agent edits for display: the viewed session first, then
 * subtree edits, then by ascending turn number.
 * @param {PullRequestAgentEdit[]} edits - The file's agent edits.
 * @param {string} currentSessionId - The session whose detail page is open.
 * @returns {PullRequestAgentEdit[]} A new array sorted for display.
 */
const sortEdits = (edits: PullRequestAgentEdit[], currentSessionId: string): PullRequestAgentEdit[] =>
  [...edits].sort(
    (a, b) =>
      Number(b.session_id === currentSessionId) - Number(a.session_id === currentSessionId) ||
      Number(b.is_subtree) - Number(a.is_subtree) ||
      (a.turn_number ?? 0) - (b.turn_number ?? 0),
  );

export { sortEdits };
